// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__dpRUX","list":"Sidebar_list__5axPW","itemBtn":"Sidebar_itemBtn__FHSSI","active":"Sidebar_active__sG79R"};